<table class="details-table" [style.height]="height" [class.striped-table]="striped">
    <tr *ngFor="let i of [].constructor(rows)">
      <td class="p-3 bold">
        <p-skeleton height="1em"></p-skeleton>
      </td>
    </tr>
</table>
